<template>
  <div>
    <a :href="sanitizeUrl(faqUrl)" class="no-underline" target="_blank" rel="noopener" :title="$t('common.faqLinkTitle')">
      <div class="d-flex align-items-center">
        <span class="hover-underline">{{ $t(i18nMessage) }}</span>
        <span class="icon icon-text_link_pfeil ml-2" aria-hidden="true"></span>
      </div>
    </a>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import config from '@/config/config';
import { urlService } from '@/services/urlService';

export default defineComponent({
  name: 'LinkFaq',
  props: {
    i18nMessage: {
      type: String,
      default: 'common.faqLink'
    }
  },
  data(){
    return{
      faqUrl: config.faqUrl
    }
  },
  methods: {
    sanitizeUrl(url: string) {
      return urlService.sanitizeThisUrl(url)
    }
  }
});
</script>

<style scoped>
.icon{
  font-size: 30px;
  padding-top:2px;
  width: 20px
}
</style>
